import React from "react";
const IconArrowSwap = (props) => /* @__PURE__ */ React.createElement("svg", {
  viewBox: "0 0 24 24",
  width: "24px",
  height: "24px",
  ...props
}, /* @__PURE__ */ React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  transform: "translate(0.600006, 0.000000)"
}, /* @__PURE__ */ React.createElement("g", {
  transform: "translate(6.000000, 7.000000) rotate(-90.000000) translate(-6.000000, -7.000000) translate(-1.000000, 1.000000)"
}, /* @__PURE__ */ React.createElement("path", {
  d: "M7.4,9.3 L9.7,7 L1.3,7 C0.6,7 0,6.4 0,5.7 C0,5 0.6,4.4 1.3,4.4 L9.7,4.4 L7.4,2.2 L7.4,2.2 C7.2,2 7,1.7 7,1.3 C7,0.6 7.6,0 8.3,0 C8.6,0 8.9,0.1 9.2,0.3 L9.2,0.3 L9.2,0.3 L9.2,0.3 L13.6,4.7 C13.8,5 14,5.4 14,5.7 C14,6.1 13.8,6.4 13.6,6.7 L9.2,11 C9,11.3 8.6,11.5 8.2,11.5 C7.5,11.5 6.9,10.9 6.9,10.2 C7,9.9 7.1,9.6 7.4,9.3 L7.4,9.3 L7.4,9.3 L7.4,9.3 Z"
})), /* @__PURE__ */ React.createElement("g", {
  transform: "translate(17.000000, 15.000000) rotate(90.000000) translate(-17.000000, -15.000000) translate(10.000000, 9.000000)"
}, /* @__PURE__ */ React.createElement("path", {
  d: "M7.4,9.3 L9.7,7 L1.3,7 C0.6,7 0,6.4 0,5.7 C0,5 0.6,4.4 1.3,4.4 L9.7,4.4 L7.4,2.2 L7.4,2.2 C7.2,2 7,1.7 7,1.3 C7,0.6 7.6,0 8.3,0 C8.6,0 8.9,0.1 9.2,0.3 L9.2,0.3 L9.2,0.3 L9.2,0.3 L13.6,4.7 C13.8,5 14,5.4 14,5.7 C14,6.1 13.8,6.4 13.6,6.7 L9.2,11 C9,11.3 8.6,11.5 8.2,11.5 C7.5,11.5 6.9,10.9 6.9,10.2 C7,9.9 7.1,9.6 7.4,9.3 L7.4,9.3 L7.4,9.3 L7.4,9.3 Z"
}))));
var IconArrowSwap_default = IconArrowSwap;
export {
  IconArrowSwap_default as default
};
